module.exports = __webpack_public_path__ + "img/umi.ea49af59.png";